import { CustomSelect } from "../../../../components/custom-select.component";
import { SelectProps } from "../../../form-types";
import { countryOptions } from "@/dentlab/src/lib/constants/countries";

export const CountrySelect: React.FC<SelectProps> = (props) => {
	return (
		<CustomSelect options={countryOptions} inputLabel="Land" {...props} />
	);
};
